<template>
<div class="form-container">
  <div class="form-region">
	   <com-page-title   ></com-page-title>
 
 <el-form :class="$store.state.operate=='详情'?'form-disabled':''" :disabled="$store.state.operate=='详情'"  ref="form" :model="form" label-width="120px">
				<el-form-item required label='标题'>
					<el-input placeholder='请填写' maxlength='200' show-word-limit clearable v-model='form.title'></el-input>
				</el-form-item>
			<!-- 	<el-form-item label='副标题'>
					<el-input v-model='form.subTitle'></el-input>
				</el-form-item>
				<el-form-item label='英文副标题'>
					<el-input v-model='form.subEnglish'></el-input>
				</el-form-item> -->
				<el-form-item  label='链接'>
					<el-input placeholder='请填写' maxlength='200' show-word-limit clearable v-model='form.urls'></el-input>
					
				</el-form-item>
				<el-form-item label='排序'><el-input placeholder='请填写' maxlength='20' show-word-limit clearable type="number" v-model='form.orders'></el-input></el-form-item>
				<el-form-item required label='图片'>
					<com-form-uploaders :limit="1" v-model="form.imgurl"></com-form-uploaders>
				</el-form-item>
				<!-- <el-form-item label='英文图片'>
		<el-input v-model='form.imgurlEnglish'></el-input>
		 </el-form-item> -->
				<el-form-item label='是否上架'>
					<el-switch v-model="form.isShow"></el-switch>
				</el-form-item>
				<!-- <el-form-item label=''>
		<el-input v-model='form.groupId'></el-input>
		 </el-form-item> -->
				<el-form-item required label='位置'>
					<el-radio-group v-model="form.position">
						<el-radio label="首页轮播">首页轮播</el-radio>
						<el-radio label="首页专区">首页专区</el-radio>
						<el-radio label="首页广告">首页广告</el-radio>
						<el-radio label="全部服务">全部服务</el-radio>
						<el-radio label="个人中心">个人中心</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item required label='链接类型'>
					<el-radio-group v-model="form.linktype">
						<el-radio label="内部页面">内部页面</el-radio>
						<el-radio label="内部导航">内部导航</el-radio>
						<el-radio label="小程序">小程序</el-radio>
						<el-radio label="h5">h5</el-radio>
					</el-radio-group>
				</el-form-item>
			
				<el-form-item required v-if="form.linktype=='小程序'" label='小程序id'>
				<el-input placeholder='请填写' maxlength='50' show-word-limit clearable v-model='form.ext'></el-input>
				 </el-form-item>
			<!-- 	<el-form-item required  label='日期'>
					<el-date-picker v-model="dateRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"  prefix-icon="none" :editable="false"   start-placeholder="开始日期"
				       end-placeholder="结束日期"
						 range-separator="">
					</el-date-picker>
				</el-form-item> -->
				
				<!-- <el-form-item label='限制日期'>
					<el-switch v-model="form.timeLimit"></el-switch>
				</el-form-item>
				 -->
				<!--  <el-form-item label=''>
		<el-input v-model='form.endTime'></el-input>
		 </el-form-item>
		<!-- <el-form-item label=''>
		<el-input v-model='form.ext'></el-input>
		 </el-form-item>
		 <el-form-item label=''>
		<el-input v-model='form.hashExt'></el-input>
		 </el-form-item>
		 <el-form-item label=''>
		<el-input v-model='form.createId'></el-input>
		 </el-form-item>
		 <el-form-item label=''>
		<el-input v-model='form.createTime'></el-input>
		 </el-form-item> -->


				<el-form-item>
					<el-button type="primary" @click="onSubmit">立即提交</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			id: { //主键id
				type: String,
				default: ''
			}
		},
		data() {

			return {
				dateRange: [], //表单限制日期
				form: {
				id:'',//ID
					title:'',//标题
					subTitle:'',//副标题
					urls:'',//链接
					orders:'',//排序
					imgurl:'',//图片
					isShow:true,//是否上架
					position:'',//位置
					linktype:'',//链接*类型
					startTime:'',//开始时间
					endTime:'',//结束时间
					extFlag:'',//扩展
					extMore:'',//扩展
					ext:'',//扩展字段
					createId:'',//创建ID
					createTime:'',//创建时间
				}
			}
		},
		methods: {
			onSubmit() { //表单提交
			if(!this.form.title){
				this.$message.error('请填写标题');return 
			}
			if(!this.form.imgurl){
				this.$message.error('请选择图片');return 
			}
			if(!this.form.position){
				this.$message.error('请选择位置');return 
			}
			if(!this.form.linktype){
				this.$message.error('请选择链接类型');return 
			}
			if(this.form.linktype=='小程序'&&!this.form.ext){
				this.$message.error('请填写小程序id');return 
			}
			// if(this.dateRange.length==0){
			// 	this.$message.error('请选择限制时间');return 
			// }
				this.form.id = this.$store.state.operate == '复制' ? '' : this.id;
				if (this.dateRange.length == 2) {
					this.form.startTime = this.dateRange[0];
					this.form.endTime = this.dateRange[1];
				}
				let url = this.form.id ? `/api/Adinfo/PostAdinfoUpdate` : `/api/Adinfo/PostAdinfoAppend`;
				let data = this.form;
				this.$axios.post(url, data).then(e => {
					this.$emit("callbackPage", {
						statusText: this.form.id ? '编辑' : '添加'
					});
				});
			}

		},
		mounted() { //根据id获取表单数据
			if (this.id) {
				this.$axios.get(`/api/Adinfo/GetAdinfo?id=${this.id}`).then(e => {
					this.form = e;
					 this.dateRange=this.form.startTime?[this.form.startTime,this.form.endTime]:[]
					if (this.$store.state.operate == '复制') {
						this.$message.success('数据已经复制到表单');
					}
				});
			}


		},
		computed: {
			storeLanguage() { //当前国际化语言
				return this.$store.state.language;
			},

		}
	}
</script>
